// extracted by mini-css-extract-plugin
export default {"list":"ProductList_list__p4MKS"};